import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-430b034e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wallet-connection" }
const _hoisted_2 = ["data-network", "data-fallback-provider"]

import { NETWORK_ID } from '@/common/constants';

interface WalletConnectionProps {
  fallbackProvider: string | null | undefined;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletConnection',
  props: {
    fallbackProvider: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      "data-widget": "m-connect",
      "data-grant-type": "signature",
      "data-client-id": "02865a407876e82f4389f70992c25323e967504d37663290f11fd49e79b607e0",
      "data-app-name": "Manifold Notifications",
      "data-delay-auth": "always",
      "data-network": _unref(NETWORK_ID),
      "data-fallback-provider": __props.fallbackProvider ? __props.fallbackProvider : undefined,
      "data-multi": "true",
      "data-message": "Please sign this message to confirm your wallet address"
    }, null, 8, _hoisted_2)
  ]))
}
}

})